<script>
    import ClickCall from '../../mixins/ClickCall.vue';
    export default {
        mixins: [ClickCall],
        methods: {
            success(response) {
                window.location.href = response.data.redirect;
            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/src/components/Triggers/CallRedirect.vue